// @flow

import type {TreeDataObj, TreeRowData} from '../typedef';

export const expandTreeNodes = (
    nodes: Array<TreeRowData<{||}>>,
    treeDataObj: TreeDataObj<{||}>
): Array<TreeRowData<{||}>> => {
    return nodes.map(tree => {
        if (tree.id === treeDataObj.treeId || tree.level > 0) {

            if (tree.id === treeDataObj.id) {
                return {
                    ...tree,
                    expanded: treeDataObj.expanded
                };
            }

            let childrenObj = {};

            if (tree.children) {
                childrenObj = {
                    children: expandTreeNodes(tree.children, treeDataObj)
                };
            }

            return {
                ...tree,
                ...childrenObj
            };
        }

        return tree;
    });
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("../typedef");
